"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectSubscriptionPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var payment_plan_1 = require("./tabs/payment_plan");
var SelectSubscriptionPage = function () {
    return ((0, jsx_runtime_1.jsx)("div", { className: "w-full flex flex-col h-full justify-center overflow-y-auto ", children: (0, jsx_runtime_1.jsx)("div", { className: "overflow-y-auto overflow-x-hidden  px-8", children: (0, jsx_runtime_1.jsx)(payment_plan_1.PaymentPlanPage, { hasBackButton: false }) }) }));
};
exports.SelectSubscriptionPage = SelectSubscriptionPage;
